import { Alert } from "@/components";
import { useModal } from "@/contexts";
import { useNewNavigate } from "@/shared/client";
import { useSetBookingCheckState } from "@/shared/client/states/bookingCheck.state";
import { getDefaultParameters } from "@/utils";
import { API_CHECK } from "@shared/server";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { CheckForm } from "./checkForm";

export const BookingCheck = () => {
    const { onNavigate } = useNewNavigate();
    const setBookingCheckState = useSetBookingCheckState();
    const { setModalContent, setIconName, openModal } = useModal();

    const onModal = () => {
        setModalContent(<Alert>조회된 예약건이 없어요</Alert>);
        setIconName("close");
        openModal();
    };

    useEffect(() => {
        setBookingCheckState(undefined);
    }, []);

    const onSubmit = async (data: { [key: string]: string }) => {
        if (confirm("조회 하시겠어요?")) {
            const res = await API_CHECK.getBookingCheck(data, getDefaultParameters().co_id);
            if (res.roomList.length > 0) {
                setBookingCheckState(res);
                onNavigate({ path: "/bookingConfirm", params: { ...data } });
            }
            if (res.status === "500" || res.roomList.length === 0) onModal();
        }
    };

    return (
        <>
            <Helmet>
                <title>Marginmax | 예약조회</title>
            </Helmet>
            <CheckForm onSubmit={onSubmit} />
        </>
    );
};
